import * as types from './mutations-types'

export default {
  [types.MY_CONSUMPTION_LIST] (state, data) {
    state.myMemberConsumption = data.dataList
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/records-of-consumption/store/mutations.js